import React, { useEffect, useRef, useState } from "react";
import Lottie from "react-lottie";
// import animationData from "../../Assets/lottie/animationData.json";
import animationData from "../../Assets/lottie/bot-animation-hello.json";
import { Tab } from "@headlessui/react";
import GetStarted from "./GetStarted";
import ChatBox from "./ChatBox";
import { useLocation } from "react-router-dom";
import { RiCustomerServiceFill } from "react-icons/ri";
import { FiHeadphones } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";

const ChatBot = ({ showModal, setShowModal }) => {
  const { t } = useTranslation("home");

  const [selectedIndex, setSelectedIndex] = useState(0);
  const location = useLocation();
  const currentUrl = location.pathname;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  console.log(currentUrl.startsWith("/ai-agent"));

  return currentUrl !== "/instruction" &&
    currentUrl !== "/rough" &&
    currentUrl !== "/result-page" &&
    !currentUrl.startsWith("/ai-agent") ? (
    <div className="fixed bottom-5 left-5 md-small:left-5 md-small:bottom-5 cursor-pointer z-50 group">
      <div className="relative flex flex-col items-end max-w-[30vw] md-small:max-w-full">
        <div
          className={`${
            showModal ? "block" : "hidden"
          } min-h-full h-[80vh] md-small:h-[90dvh] rounded-3xl bg-white absolute bottom-14 left-0 md-small:bottom-14 !z-[200]`}
        >
          <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
            <Tab.List className="h-0">
              {/* <Tab></Tab> */}
              <Tab></Tab>
            </Tab.List>
            <Tab.Panels>
              {/* <Tab.Panel>
                  <GetStarted setSelectedIndex={setSelectedIndex} />
                </Tab.Panel> */}
              <Tab.Panel>
                <ChatBox setShowModal={setShowModal} showModal={showModal} />
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>

        {/* <div
            onClick={() => setShowModal((prevState) => !prevState)}
            className="relative group md-small:hidden [&>svg]:!z-[300] [&>div]:relative [&>div]:bottom-0 [&>div]:left-0"
          > */}
        {/* <Lottie options={defaultOptions} height={150} width={150} /> */}
        {/* <RiCustomerServiceFill size={40} color="#318dfb" className="z-50" /> */}

        {/* <section
              className={`w-0 px-0 max-h-[80px] flex group-hover:w-[30ch] group-hover:px-5 flex-col gap-2 fixed bottom-[6%] left-[50px] bg-[#F1F7FF] py-2.5 rounded-xl !z-30 transition-all duration-300 overflow-hidden`}
            >
              <h5 className="font-bold overflow-x-hidden truncate">
                Hello, I am Uva!
              </h5>
              <p className="overflow-x-hidden truncate">
                How may i help you today?
              </p>
            </section>
          </div> */}
        <button
          onClick={() => setShowModal((prevState) => !prevState)}
          className={`bg-[#1F74F1] text-white md-max:text-xs flex gap-2 duration-200 items-center w-max ${showModal ? "px-2" : "px-4"} py-2 rounded-full cursor-pointer`}
        >
          {showModal ? (
            <IoClose size={20} />
          ) : (
            <>
              <FiHeadphones />
              {t("support")}
            </>
          )}
        </button>
      </div>
    </div>
  ) : null;
};

export default ChatBot;
